"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    domainIDToRegionEnv: ()=>domainIDToRegionEnv,
    regionEnvToDomainID: ()=>regionEnvToDomainID,
    currentDomainID: ()=>currentDomainID,
    domainIDUtil: ()=>domainIDUtil,
    getCurrentDomainID: ()=>getCurrentDomainID
});
const external_tool_js_namespaceObject = require("../tool.js");
const external_domain_id_config_js_namespaceObject = require("./domain-id.config.js");
const external_domain_id_service_js_namespaceObject = require("./domain-id.service.js");
const getCurrentDomainID = ()=>external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.getCurrentDomainID();
const { currentDomainID } = external_domain_id_service_js_namespaceObject.bytecloudDomainIDService;
const domainIDToRegionEnv = (domainID)=>({
        region: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.getRegion(domainID),
        env: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.getEnv(domainID)
    });
const regionEnvDomainIDMap = (()=>Object.keys(external_domain_id_config_js_namespaceObject.regionEnvMap).reduce((prev, curr)=>{
        const regionEnv = external_domain_id_config_js_namespaceObject.regionEnvMap[curr];
        prev[`${regionEnv.region}-${regionEnv.env}`] = curr;
        return prev;
    }, {}))();
const regionEnvToDomainID = (region, env)=>{
    const domainID = regionEnvDomainIDMap[`${region}-${env}`];
    if (domainID) return domainID;
    throw new external_tool_js_namespaceObject.CommonLibError('regionEnvToDomainID', `RegionEnv ${region}-${env} is invalid!`);
};
const domainIDUtil = {
    isLocal: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('local'),
    isSandbox: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sandbox'),
    isHuailai: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('hl'),
    isHL: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('hl'),
    isPD: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('pd'),
    isLQ: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('lq'),
    isBoe: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('boe'),
    isUS: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('us'),
    isI18n: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('i18n'),
    isI18nSG: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('i18n-sg'),
    isI18nBD: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('i18n-bd'),
    isI18nBDDE: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('i18n-bd-de'),
    isOnline: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('online'),
    isBoeI18n: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('boe-i18n'),
    isTx: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('tx'),
    isTxTt: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('tx-tt'),
    isTTPUS: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('ttp-us'),
    isTxLimited: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('ttp-us-limited'),
    isTTPUSLimited: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('ttp-us-limited'),
    isXFL: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('xfl'),
    isSinfXfl: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinf-xfl'),
    isSinfXflBoe: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinf-xfl-boe'),
    isSinfBoe: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinf-boe'),
    isSinf: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinf'),
    isSinfI18n: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinfi18n'),
    isSinfOnlineA: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('sinfonlinea'),
    isVolcgroup: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('volcgroup'),
    isVolcBoe: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('volcgroup-boe'),
    isTTPROW: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('ttp-row'),
    idTTPROWSG: external_domain_id_service_js_namespaceObject.bytecloudDomainIDService.is('ttp-row-sg')
};
exports.currentDomainID = __webpack_exports__.currentDomainID;
exports.domainIDToRegionEnv = __webpack_exports__.domainIDToRegionEnv;
exports.domainIDUtil = __webpack_exports__.domainIDUtil;
exports.getCurrentDomainID = __webpack_exports__.getCurrentDomainID;
exports.regionEnvToDomainID = __webpack_exports__.regionEnvToDomainID;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "currentDomainID",
    "domainIDToRegionEnv",
    "domainIDUtil",
    "getCurrentDomainID",
    "regionEnvToDomainID"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
